import { render, staticRenderFns } from "./RoleTemplates.vue?vue&type=template&id=31c6fc4e&"
import script from "./RoleTemplates.vue?vue&type=script&lang=js&"
export * from "./RoleTemplates.vue?vue&type=script&lang=js&"
import style0 from "./RoleTemplates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports